<template lang="pug">
.video-wrapper(:class="serviceClass")
  iframe#player(
    type="text/html"
    :src="videoSrc"
    frameborder="0"
    allowfullscreen
  )
</template>

<script>
import { mapGetters } from 'vuex';
import * as getterTypes from '@/store/types/getters';

export default {
  name: 'video-player',
  computed: {
    ...mapGetters({
      account: getterTypes.GET_ACCOUNT,
    }),
    color() {
      switch (this.account.abbreviation) {
        case 'CWO':
          return 'fdcc22';
        case 'FFC':
          return '207ead';
        default:
          return 'ffffff';
      }
    },
    serviceClass() {
      return `is-${this.video.service}`;
    },
    videoSrc() {
      switch (this.video.service) {
        case 'youtube':
          return `https://www.youtube.com/embed/${this.video.video_id}?autoplay=1&modestbranding=1&showinfo=0`;
        case 'vimeo':
          return `https://player.vimeo.com/video/${this.video.video_id}?title=false&color=${this.color}&byline=0&portrait=0&title=0`;
        default:
          return null;
      }
    },
  },
  data() {
    return {};
  },
  methods: {},
  props: {
    video: {
      type: Object,
    },
  },
};
</script>

<style lang="scss">
.video-wrapper {
  //position: relative;
  // padding-bottom: 56.25%; /* 16:9 */
  height: 0;
  // width: 820px;
  &.is-vimeo {
    iframe {
      //top: -12px;
    }
  }
  iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
}
</style>
